import Vue from "vue";
import settingsService from "../../services/settings/settings";
import { Photo } from "../../services/settings/entities/photo.interface";
import { Page } from "../../services/settings/entities/page.interface";
import { uploadTask, deleteTask } from "../../firebase";
import constants from "../../config/constants";
import { SettingsState } from "./states/settings.state.interface";

export default {
  namespaced: true,
  state: {
    photos: [],
    photoTypes: [constants.PHOTO_TYPE.CAROUSEL, constants.PHOTO_TYPE.CLIENT],
    pages: [],
    customPages: [],
  },
  getters: {
    getPhotos: (state: SettingsState) => state.photos,
    getPhotoTypes: (state: SettingsState) => state.photoTypes,
    getPages: (state: SettingsState) => state.pages,
    getCustomPages: (state: SettingsState) => state.customPages,
  },
  mutations: {
    setPhotos(state: SettingsState, photos: Array<Photo>) {
      Vue.set(state, "photos", photos);
    },
    setPages(state: SettingsState, pages: Array<Page>) {
      Vue.set(
        state,
        "pages",
        pages.filter((p) => !p.pageIsCustom)
      );
      Vue.set(
        state,
        "customPages",
        pages.filter((p) => p.pageIsCustom)
      );
    },
  },
  actions: {
    getPhotos: async (context: any) => {
      await settingsService.getPhotos().then((response: any) => {
        context.commit("setPhotos", response.data.photos);
      });
    },
    getPages: async (context: any) => {
      await settingsService.getPages().then((response: any) => {
        context.commit("setPages", response.data.pages);
      });
    },
    createPage: async (context: any, payload: any) => {
      let updated = false;
      await settingsService.addPage(payload).then(async (response: any) => {
        updated = response.data.created;
        await settingsService.getPages().then((response: any) => {
          context.commit("setPages", response.data.pages);
        });
      });
      return updated;
    },
    updatePage: async (context: any, payload: any) => {
      let updated = false;
      await settingsService.updatePage(payload).then(async (response: any) => {
        updated = response.data.updated;
        await settingsService.getPages().then((response: any) => {
          context.commit("setPages", response.data.pages);
        });
      });
      return updated;
    },
    deletePage: async (context: any, payload: any) => {
      let deleted = false;
      await settingsService
        .deletePage(payload.pageID)
        .then(async (response: any) => {
          deleted = response.data.deleted;
        });

      return deleted;
    },
    addPhoto: async (context: any, payload: any) => {
      let photoID = 0;
      let photoURL: any;
      let updated = false;
      await settingsService.addPhoto(payload).then(async (response: any) => {
        if (payload.photoUrl) {
          await settingsService.getPhotos().then((response: any) => {
            context.commit("setPhotos", response.data.photos);
          });
          updated = response.data;
          return;
        }
        photoID = response.data.photoID;
        photoURL = await uploadTask(
          photoID,
          constants.TABLE.PHOTO,
          payload.file
        );
        const photo = {
          photoId: photoID,
          photo: photoURL,
          photoType: payload.photoType,
        };
        await settingsService.updatePhoto(photo).then(async (response: any) => {
          updated = response.data.updated;
          await settingsService.getPhotos().then((response: any) => {
            context.commit("setPhotos", response.data.photos);
          });
        });
      });

      return updated;
    },
    deletePhoto: async (context: any, payload: any) => {
      let deleted = false;
      await settingsService
        .deletePhoto(payload.photoID)
        .then(async (response: any) => {
          deleted = response.data.deleted;
          if (payload.photoKind != constants.PHOTO_KIND.VIDEO) {
            deleted = await deleteTask(payload.photoURL);
          }
        });

      return deleted;
    },
  },
};
